/**
 * Classe que testa os tipo Pick list
 * @author: Adalto Junior
 * DATE: 30/09/2014
 */


Monet.Format = Monet.Format || {};
Monet.Format.PICKLIST = (function () {

    function PICKLIST(value) {

        Monet.Format.Base.apply(this, arguments);

        this.toGrid = function() {
            if (value && value.match(/^((signature|arrival|departure|cancel)Conformity)$/)) {
                this.value = Monet.FormBuilder.CreateIconConformity(true);
            } else if (value && value.match(/^((signature|arrival|departure|cancel)Unconformity)$/)) {
                this.value = Monet.FormBuilder.CreateIconConformity(false);
            }
            return this;
        };

    }

    return PICKLIST;

}());
